import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { usePaymentMethodsForm } from '../../../../context/PaymentMethodsFormContext'

export const ModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { closeModal, isLoading, isProcessing, submitForm } = usePaymentMethodsForm()

  const handleCloseClick = () => {
    closeModal()
  }

  const handleSaveButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <ButtonsGroup>
      <Button disabled={isProcessing} onClick={handleCloseClick} variant="text">
        {t('external_invoices.payment_methods_modal.actions.cancel')}
      </Button>
      <Button disabled={isProcessing} loading={isLoading} onClick={handleSaveButtonClick}>
        {t('external_invoices.payment_methods_modal.actions.save')}
      </Button>
    </ButtonsGroup>
  )
}
